import { Box, Typography, Button } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const ModalSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.95rem',
}));

export const ButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
  justifyContent: 'flex-end',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  flex: 1,
  borderColor: theme.palette.error.main,
  color: theme.palette.error.main,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: theme.spacing(1.2),
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.04),
  }
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: theme.spacing(1.2),
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: 'none',
  },
}));
